/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/login/login.component';
const styles_LoginComponent:any[] = ['.gpis-error-panel[_ngcontent-%COMP%] { color: red; padding: 5rem; font-weight: bold; }'];
export const RenderType_LoginComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_LoginComponent,data:{}});
export function View_LoginComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h1',[['class',
      'gpis-error-panel']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    Authorization error. User not allowed in this page.\n']))],
      (null as any),(null as any));
}
export function View_LoginComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'gpis-login',([] as any[]),
      (null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
      i0.ɵdid(49152,(null as any),0,i1.LoginComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const LoginComponentNgFactory:i0.ComponentFactory<i1.LoginComponent> = i0.ɵccf('gpis-login',
    i1.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9sb2dpbi9sb2dpbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9sb2dpbi9sb2dpbi5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Vc2Vycy9OUkVHRTMvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL2xvZ2luL2xvZ2luLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9OUkVHRTMvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL2xvZ2luL2xvZ2luLmNvbXBvbmVudC50cy5Mb2dpbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxoMSBjbGFzcz1cImdwaXMtZXJyb3ItcGFuZWxcIj5cclxuICAgIEF1dGhvcml6YXRpb24gZXJyb3IuIFVzZXIgbm90IGFsbG93ZWQgaW4gdGhpcyBwYWdlLlxyXG48L2gxPiIsIjxncGlzLWxvZ2luPjwvZ3Bpcy1sb2dpbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUEsZ0JBQTZCOzs7O29CQ0E3QjtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/login/login.component.ngfactory.ts